module.exports = __webpack_public_path__ + "static/img/32.05dc991c.jpg";